import { Button } from "Components/Button";
import { ArrowDownUp } from "lucide-react";
import { Box } from "styles/globalComponents";
import { Order, TableItem } from "./TableItem";
import { TableBody } from "../styles";

export type SortBy = "date" | "home_collect_date";
export type SortDir = "asc" | "desc";

interface TableItemsProps {
  orders: Order[];
  onOpenChangeStatus: (orderId: number) => void;
  sortBy: SortBy;
  sortDir: SortDir;
  onSort: (sortBy: SortBy) => void;
}

export const TableItems = ({
  orders,
  onOpenChangeStatus,
  sortBy,
  sortDir,
  onSort,
}: TableItemsProps) => {
  const columns = [
    {
      title: (
        <Box display="flex" align="center" gap="0">
          Data de criação
          <Button
            textButton
            onClick={() => onSort("date")}
            aria-label={`Ordenar por data de criação ${
              sortBy === "date" ? sortDir : "desc"
            }`}
          >
            <ArrowDownUp size={16} />
          </Button>
        </Box>
      ),
      key: "date",
      className: "item-width",
    },
    {
      title: (
        <Box display="flex" align="center" gap="0">
          Data de agendamento
          <Button
            textButton
            onClick={() => onSort("home_collect_date")}
            aria-label={`Ordenar por data de agendamento ${
              sortBy === "home_collect_date" ? sortDir : "desc"
            }`}
          >
            <ArrowDownUp size={16} />
          </Button>
        </Box>
      ),
      key: "schedule_date",
      className: "item-width",
    },
    {
      title: (
        <>
          ID pedido
          <br /> na origem
        </>
      ),
      key: "origin_order_id",
    },
    {
      title: "Pagador",
      key: "pacient",
    },
    {
      title: "CPF",
      key: "cpf",
    },
    {
      title: "E-mail",
      key: "email",
    },
    {
      title: "Parceiro",
      key: "client",
    },
    {
      title: "Status",
      key: "status",
    },
    {
      title: "Motion",
      key: "integration",
      className: "table-action-order",
    },
    {
      title: "Valor final",
      key: "paid_value",
    },
    {
      title: "",
      key: "action",
      className: "table-action-order",
    },
  ];

  return (
    <div className="page-content-list">
      <TableBody className="table-content small-separate details">
        <thead>
          <tr>
            {columns.map((columnsItem) => (
              <th key={columnsItem.key} className={columnsItem.className || ""}>
                {columnsItem.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {orders.map((item) => (
            <TableItem
              key={item.order_id}
              order={item}
              onOpenChangeStatus={onOpenChangeStatus}
            />
          ))}
        </tbody>
      </TableBody>
    </div>
  );
};
